import React, { Component } from "react";
import { Link } from "react-router-dom";
import i18n from "i18next";
import { AppRoutes } from "../app-routes.js";
import { Translations } from "../i18n.js";
import SEO from "../components/seo.jsx";

export default class MenuPage extends Component {
  state = {
    isLanguageMenuOpen: false
  };

  constructor(props) {
    super(props);
    this.title = i18n.t("app-name");
    this.translations = [];
    for (let langCode in Translations) {
      this.translations.push({
        path: langCode,
        name: Translations[langCode].name
      });
    }
  }

  closeLanguageMenu = () => {
    this.setState({ isLanguageMenuOpen: false });
  };

  toggleLanguageMenu = () => {
    this.setState((state) => ({
      isLanguageMenuOpen: !state.isLanguageMenuOpen
    }));
  };

  render() {
    const { isLanguageMenuOpen } = this.state;

    return (
      <div>
        <SEO />
        <nav className="menu">
          <h1>{this.title}</h1>
          <ul>
            {AppRoutes.map((route, i) =>
              <li key={i}>
                <Link
                  className={`btn green ${route.path === "addition" || route.path === "subtraction" ? "menu-btn--compact" : ""}`}
                  to={`/${i18n.language}/${route.path}/`}
                >
                  {i18n.t(route.path)}
                </Link>
              </li>)}
          </ul>
        </nav>
        <div className="language-switcher">
          <button
            className="dropbtn"
            type="button"
            onClick={this.toggleLanguageMenu}
            aria-haspopup="dialog"
            aria-expanded={isLanguageMenuOpen}
            aria-label={i18n.t("language")}
            title={i18n.t("language")}
          >
          </button>
          {isLanguageMenuOpen && (
            <div className="language-menu-backdrop" onClick={this.closeLanguageMenu}>
              <div
                className="language-menu-panel"
                role="dialog"
                aria-modal="true"
                aria-label={i18n.t("language")}
                onClick={event => event.stopPropagation()}
              >
                <div className="language-menu-title">{i18n.t("language")}</div>
                <div className="language-menu-list">
                  {this.translations.map((translation, i) =>
                    <a
                      key={i}
                      className="language-menu-option"
                      hrefLang={translation.path}
                      href={`/${translation.path}/`}
                    >
                      {translation.name}
                    </a>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
